// eslint-disable-next-line import/prefer-default-export
export const neighborhoodsCarousel = () => {
  const carouselWrapper = document.querySelector(".market-neighborhoods");

  if(carouselWrapper) {
    const carousel = carouselWrapper.querySelector(".carousel");
    const items = carousel && carousel.querySelectorAll(".item");
    const prevButton = carouselWrapper.querySelector(".carousel-nav.prev");
    const nextButton = carouselWrapper.querySelector(".carousel-nav.next");

    let currentIndex = 0;
    const itemsPerPage = 6;
    let itemWidth;

    function setupCarousel() {
      if(itemWidth * items.length < carousel.offsetWidth){
        carousel.classList.add('noscroll');
      } else {
        carousel.classList.remove('noscroll');
      }
    }

    const pageLoaded = () => {
      if (items && items[0]) {
        itemWidth = items[0].offsetWidth
        setupCarousel();
      }
    }

    function resize() {
      if (items && items[0]) {
        itemWidth = items[0].offsetWidth;
        setupCarousel();
      }
    }

    function updateCarousel() {
      items.forEach((item) => {
          item.style.transform = `translateX(-${
            currentIndex * itemWidth
          }px)`;
        })
    }

    function prevItem(e) {
      e.preventDefault();
      currentIndex = Math.max(currentIndex - 1, 0);
      updateCarousel();
    }

    function nextItem(e) {
      e.preventDefault();
      currentIndex = Math.min(currentIndex + 1, items.length - itemsPerPage);
      updateCarousel();
    }

    if (prevButton) {
      prevButton.addEventListener("click", prevItem);

    }
    if (nextButton) {
      nextButton.addEventListener("click", nextItem);
    }

    window.addEventListener("resize", resize);
    window.addEventListener("load", pageLoaded);
  }
};



// WEBPACK FOOTER //
// ./src/templates/components/market-neighborhoods/market-neighborhoods.js